import { render, staticRenderFns } from "./EfficiencyTestsCreate.vue?vue&type=template&id=87f86f26&scoped=true"
import script from "./EfficiencyTestsCreate.vue?vue&type=script&lang=js"
export * from "./EfficiencyTestsCreate.vue?vue&type=script&lang=js"
import style0 from "./EfficiencyTestsCreate.vue?vue&type=style&index=0&id=87f86f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f86f26",
  null
  
)

export default component.exports